export default __webpack_public_path__ + "static/mhw-3f2bee01d52a8517b127ecc8b42d0644.webp";